import { put, call } from 'redux-saga/effects';
import { aflt_rateCardsList, aflt_rateCardsAll, aflt_rateCardsAdd, aflt_rateCardsUpdate, aflt_rateCardsDelete, aflt_departmentRateCardsList, aflt_departmentRateCardsUpdate } from '../../../services/settings/affiliates/aflt_rateCardsService';

import * as types from '../../../actions';

export function* aflt_rateCardsListSaga(payload) { 
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(aflt_rateCardsList, payload);
      yield put({ type: types.RATE_CARDS_LIST_AFFILIATE_SUCCESS, response }); 
    } catch(error) {
      yield put({ type: types.RATE_CARDS_LIST_AFFILIATE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
} 

export function* aflt_rateCardsAllSaga(payload) { 
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(aflt_rateCardsAll, payload);
    yield put({ type: types.RATE_CARDS_ALL_AFFILIATE_SUCCESS , response }); 
  } catch(error) {
    yield put({ type: types.RATE_CARDS_ALL_AFFILIATE_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
} 

export function* aflt_rateCardsAddSaga(payload) { 
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(aflt_rateCardsAdd, payload);
      yield put({ type: types.RATE_CARDS_ADD_AFFILIATE_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.RATE_CARDS_ADD_AFFILIATE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
}

export function* aflt_rateCardsUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(aflt_rateCardsUpdate, payload);
    yield put({ type: types.RATE_CARDS_UPDATE_AFFILIATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.RATE_CARDS_UPDATE_AFFILIATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* aflt_rateCardsDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(aflt_rateCardsDelete, payload);
    yield put({ type: types.RATE_CARDS_DELETE_AFFILIATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.RATE_CARDS_DELETE_AFFILIATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* aflt_departmentRateCardsListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(aflt_departmentRateCardsList, payload);
    yield put({ type: types.DEPT_RATECARDS_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.DEPT_RATECARDS_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* aflt_departmentRateCardsUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(aflt_departmentRateCardsUpdate, payload);
    yield put({ type: types.DEPT_RATECARDS_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.DEPT_RATECARDS_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
} 

